module.exports = __webpack_public_path__ + "img/translifeline.47317977.png";